import { render, staticRenderFns } from "./SpaceInviteAdmin.vue?vue&type=template&id=7f2f9365&"
import script from "./SpaceInviteAdmin.vue?vue&type=script&lang=js&"
export * from "./SpaceInviteAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports